"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isDecimalNumber;
function isDecimalNumber(number) {
  return number % 1 !== 0;
}